<template>
    <main>
        <div class="flex dashboard-wrapper">
            <div class="w-[15%] bg-white">
                <Sidebar></Sidebar>
            </div>

            <div class="w-[85%]">
                <Header></Header>

                <div class="dashboard-content p-5 px-10 pb-20 min-h-screen bg-white">
                    <h2 class="mb-4 font-bold text-3xl">{{ currentTitle }}</h2>

                    <BoxesCountDashboard :data="boxesData"></BoxesCountDashboard>

                    <div class="mt-14 flex gap-10">
                        <div class="w-full max-w-[65%]">
                            <!-- <Chart type="polarArea" :data="chartData" :options="chartOptions" class="w-full md:w-30rem" /> -->
                            <Chart type="bar" :data="barData" :options="barOptions" class="h-full" />
                        </div>

                        <div class="w-full max-w-[35%]">
                            <Chart type="pie" :data="chartData" :options="chartOptions" class="w-full md:w-30rem" />
                        </div>
                    </div>
                </div>

                <Footer></Footer>
            </div>
        </div>
    </main>
</template>

<script>
import Header from '@/components/Dashboard/HeaderDashboard.vue'
import Footer from '@/components/Dashboard/FooterDashboard.vue'
import Sidebar from '@/components/Dashboard/SidebarDashboard.vue'
import BoxesCountDashboard from '@/components/Dashboard/BoxesCountDashboard.vue'

import { authStore } from '@/store/authStore'
import authService from '@/services/authService'
import customersService from '@/services/customersService'
import Chart from 'primevue/chart'
import initService from '@/services/initService'

const date = new Date()

export default {
    name: 'dashboard-view',
    components: {
        Header, Footer, Sidebar, BoxesCountDashboard, Chart
    },
    data() {
        return {
            currentTitle: "",
            boxesData: {
                customers: 0,
                hirings: 0,
                hirings_month: 0,
                customer_vehicles: 0,
            },
            chartData: null,
            chartDataArray: [],
            chartOptions: null,
            barOptions: null,
            barData: null
        }
    },
    methods: {
        getChartData() {
            initService.getAllNumbers().then((response) => {
                const data = response.data
                this.boxesData = {
                    customers: data.customers || 0,
                    hirings: data.hirings || 0,
                    hirings_month: data.hirings_month || 0,
                    customer_vehicles: data.customer_vehicles || 0,
                }
                this.chartDataArray = [
                    this.boxesData.customers,
                    this.boxesData.hirings,
                    this.boxesData.hirings_month,
                    this.boxesData.customer_vehicles
                ]
                this.chartData = this.setChartData();
                this.chartOptions = this.setChartOptions();
                
                if (data.monthly) {
                    this.barData = this.setBarData(data.monthly);
                }
            })
        },
        setChartData() {
            const documentStyle = getComputedStyle(document.body);

            return {
                labels: [
                    'Total de Clientes',
                    'Contratatações',
                    `Contratações em ${date.getMonth()+1}/${date.getFullYear()}`,
                    'Total de Veículos'
                ],
                datasets: [
                    {
                        data: this.chartDataArray,
                        backgroundColor: [
                            documentStyle.getPropertyValue('--blue-500') || '#3B82F6',
                            documentStyle.getPropertyValue('--red-400') || '#F87171',
                            documentStyle.getPropertyValue('--purple-500') || '#8B5CF6',
                            documentStyle.getPropertyValue('--green-500') || '#10B981',
                        ],
                        hoverBackgroundColor: [
                            documentStyle.getPropertyValue('--blue-700') || '#1D4ED8',
                            documentStyle.getPropertyValue('--red-600') || '#DC2626',
                            documentStyle.getPropertyValue('--purple-700') || '#6D28D9',
                            documentStyle.getPropertyValue('--green-700') || '#047857',
                        ]
                    }
                ]
            };
        },
        setChartOptions() {
            const documentStyle = getComputedStyle(document.documentElement);
            const textColor = documentStyle.getPropertyValue('--text-color');

            return {
                plugins: {
                    legend: {
                        labels: {
                            usePointStyle: true,
                            color: textColor
                        }
                    }
                }
            };
        },
        setBarData(monthly = { customers: [], vehicles: [], hirings: [] }) {
            const documentStyle = getComputedStyle(document.documentElement);

            return {
                labels: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                datasets: [
                    {
                        type: 'line',
                        label: 'Novos Clientes',
                        borderColor: documentStyle.getPropertyValue('--blue-500') || '#3B82F6',
                        borderWidth: 3,
                        fill: false,
                        tension: 0.4,
                        data: monthly.customers || []
                    },
                    {
                        type: 'bar',
                        label: 'Novos Veículos',
                        backgroundColor: documentStyle.getPropertyValue('--green-400') || '#34D399',
                        data: monthly.vehicles || [],
                        borderColor: 'white',
                        borderWidth: 2
                    },
                    {
                        type: 'bar',
                        label: 'Contratações',
                        backgroundColor: documentStyle.getPropertyValue('--purple-400') || '#A78BFA',
                        data: monthly.hirings || []
                    }
                ]
            };
        },
        setBarOptions() {
            const documentStyle = getComputedStyle(document.documentElement);
            const textColor = documentStyle.getPropertyValue('--text-color');
            const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
            const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

            return {
                maintainAspectRatio: false,
                aspectRatio: 0.6,
                plugins: {
                    legend: {
                        labels: {
                            color: textColor
                        }
                    }
                },
                scales: {
                    x: {
                        ticks: {
                            color: textColorSecondary
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    },
                    y: {
                        ticks: {
                            color: textColorSecondary
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    }
                }
            };
        }
    },
    beforeMount() {
        
    },
    beforeCreate() {
        //authService.checkUserRole()
    },
    mounted() {
        const auth = authStore()
    
        this.barData = this.setBarData()
        this.barOptions = this.setBarOptions()
        this.getChartData()

        customersService.getLocalCustomers()

        this.currentTitle = this.$route.meta.title
        this.$watch("$route", () => {
            this.currentTitle = this.$route.meta.title;
        });
    },
}
</script>

<style lang="scss">
</style>